import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import styles from "./AddBattery.module.scss";
import { getRequestInService as getRequest } from "services/axiosServiceBaseClient";
import { useHistory } from "react-router-dom";
import Master from "../Master";
import { decryptWithAES } from "components/common/encyptDecrypt";
import notificationService from "services/notification.service";
import TextField from "@material-ui/core/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  getRequestInAssets as getRequestOnEnterprise,
  postRequestInAssets as postRequest,
  putRequestInAssets as putRequest,
} from "services/axiosAssetsBaseClient";
import { getRequestInFileDownload } from "services/axiosFileDownloadService";
import LocalStorageService from "services/tokenlocalstorage.service";
import jwtDecode from "jwt-decode";
import tokenlocalstorageService from "services/tokenlocalstorage.service";
import ReactTooltip from "react-tooltip";
import moment, { utc } from "moment";

var email = undefined;
var action = "Submit";
var title = "Add Driver";
var view = undefined;
var onlyView = false;
var id = undefined;
var fileName = "";
var tempExt = "";
var trimeFileName = "";
var fileIndexValue = "";
var utcTime;

function AddDriverForm(props) {
  view = props?.match?.params?.view;
  id = props?.match?.params?.id;

  const initialFormValues = {
    enterpriseName: "",
    dateOfBirth: "",
    dlExpiry: "",
    dlNumber: "",
    stateId: -1,
    cityId: -1,
    address: "",
    email: "",
    mobile_no: "",
    isActive: true,
    firstName: "",
    enterpriseId: "",
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState("");
  const [enterpriseState, setEnterpriseState] = useState([]);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [updateState, setUpdateState] = useState("");
  const [updateCity, setUpdateCity] = useState("");
  const [updateEnterprise, setUpdateEnterprise] = useState(
    LocalStorageService.get("enterpriseName")
  );
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [choosenFileName, setChoosenFileName] = useState("No file Choosen");
  const [file, setFile] = useState(null);
  const [tempChoosenFileName, setTempChoosenFileName] =
    useState("No file Choosen");
  const [toggleRemoveBtn, setToggleRemoveBtn] = useState(true);
  // setUpdateEnterprise(LocalStorageService.get("enterpriseName"));
  const getCountryList = useCallback(async (string) => {
    await getRequestOnEnterprise("getCountries")
      .then((res) => {
        if (res.data != null) {
          setCountry(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getStateList = useCallback(async (string) => {
    await getRequestOnEnterprise(`getStates?countryId=${string}`)
      .then((res) => {
        if (res.data != null) {
          setState(res?.data);
        }
        if (res.data.length == 0) {
          setCity([]);
          setFormValues((data) => ({
            ...data,
            stateId: -1,
            countryId: -1,
            cityId: -1,
          }));
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getCitList = useCallback(async (stateId) => {
    await getRequestOnEnterprise(`getCities?stateId=${stateId}`)
      .then((res) => {
        if (res.data != null) {
          setCity(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getCountryList();
  }, [getCountryList]);

  const getEnterprise = useCallback(async () => {
    // await getRequest("enterprise/get?offset=0&pageSize=500")
    //   .then((res) => {
    //     if (res && res?.data && res?.data?.enterpriseDetailDtoList.length >= 1) {
    //       setEnterpriseState(res?.data?.enterpriseDetailDtoList);
    //     }
    //   })
    //   .catch((err) => {
    //     console.error("Error", err);
    //   });
  }, []);

  const getDriverDataById = useCallback(
    async (id) => {
      await getRequestOnEnterprise("driver/getDriverById?id=" + id)
        .then((res) => {
          if (res.data != null) {
            patchForm(res.data);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    [getEnterprise]
  );

  useEffect(() => {
    getEnterprise();
    getStateList(1);
    if (id !== undefined && view == undefined) {
      action = "Update";
      title = "Update Driver";
      onlyView = false;
      getDriverDataById(id);
    } else if (id !== undefined && view !== undefined) {
      action = "View";
      title = "View Driver";
      onlyView = true;
      getDriverDataById(id);
    } else {
      onlyView = false;
      title = "Add Driver";
      action = "Submit";
    }
  }, []);

  const patchForm = (data) => {
    if (data?.stateId) {
      setUpdateState(data.state);
      setUpdateCity(data.city);
      getCitList(data?.stateId);
    }
    setFormValues({
      ...formValues,
      id: data.id,
      enterpriseName: data.enterpriseName,
      dateOfBirth: data.dob,
      dlExpiry: data.dlExpiry,
      dlNumber: data.dlNumber,
      stateId: data.stateId,
      cityId: data.cityId,
      address: data.address,
      firstName: data.firstName,
      email: data.email,
      mobile_no: data.mobile
        ? data.mobile.includes("+91")
          ? data.mobile.split("+91")[1]
          : data.mobile
        : "",
      isActive: data.isActive,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });

    if (name === "stateId") {
      getCitList(value);
      setFormValues({ ...formValues, stateId: value, cityId: "" });
      state.find((info) => {
        if (info.id == value) {
          setUpdateState(info.name);
        }
      });
    }
    if (name === "cityId") {
      city.find((info) => {
        if (info.id == value) {
          setUpdateCity(info.name);
        }
      });
    }

    if (name === "mobile_no") {
      setFormValues({ ...formValues, [name]: value.replace(/\D/g, "") });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let result = validate(formValues, file);
    if (
      Object.values(result).every((x) => {
        return x === "";
      })
    ) {
      formValues.mobile = "+91" + formValues.mobile_no;
      utcTime =
        moment(formValues.dlExpiry).format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var utcTimeDOB =
        moment(formValues.dateOfBirth).format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z";
      var formVal = JSON.parse(JSON.stringify(formValues));
      formValues.mobile = "+91" + formValues.mobile_no;
      // delete formValues.mobile_no;
      if (action === "Update") {
        // delete formVal["firstName"];
        delete formVal["mobile_no"];
      }
      delete formVal["dlExpiry"];
      delete formVal["dateOfBirth"];
      formVal = {
        ...formVal,
        dlExpiry: formValues.dlExpiry ? utcTime : "",
        dob: formValues.dateOfBirth ? utcTimeDOB : "",
      };
      setButtonDisabled(true);

      if (action === "Submit") {
        try {
          postRequest("driver/addDriver", JSON.stringify(formVal))
            .then((res) => {
              if (res && res?.data) {
                history.push({
                  pathname: "/Users",
                  state: { table: 2, compomentRenderType: "view" },
                });
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
                setButtonDisabled(false);
              }
            })
            .catch((error) => {
              setButtonDisabled(false);
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.response?.data?.message
              );
              return error;
            });
        } catch (error) {
          console.log(error);
        }
      }
      if (action === "Update") {
        try {
          putRequest("driver/updateDriver", JSON.stringify(formVal))
            .then((res) => {
              if (res && res?.data) {
                history.push({
                  pathname: "/Users",
                  state: { table: 2, compomentRenderType: "view" },
                });
                notificationService.showNonBlacklisted(
                  res?.config?.url,
                  res?.data?.message
                );
                setButtonDisabled(false);
              }
            })
            .catch((error) => {
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.response?.data?.message
              );
              setButtonDisabled(false);
              return error;
            });
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const validate = (formValues) => {
    const errors = {};

    if (!formValues.firstName || formValues.firstName === "-1") {
      errors.firstName = "First name is required!";
    } else if (!/^[A-Z a-z]+$/i.test(formValues.firstName)) {
      errors.firstName = "Please enter a valid name(only alphabets)!";
    } else if (formValues.firstName.trim() === "") {
      errors.firstName = "This is not a valid name";
    } else {
      errors.firstName = "";
    }

    if (!formValues.mobile_no) {
      errors.mobile_no = "Phone number is required!";
    } else if (formValues.mobile_no.length !== 10) {
      errors.mobile_no =
        "This is not a valid contact number, required 10 digits";
    } else {
      errors.mobile_no = "";
    }

    // if (!formValues.email) {
    //   errors.email = "Email Id is required!";
    // } else if (
    if (!/^([\w.-]+@([\w-]+\.)+[\w-]{2,4})?$/i.test(formValues.email)) {
      errors.email = "This is not a valid emailId format!";
    } else {
      errors.email = "";
    }

    if (
      formValues.address &&
      !/^[ A-Za-z0-9_@./#&+\-,]*$/i.test(formValues.address)
    ) {
      errors.address =
        "Only Accept alphanumeric and some special character .&#@/,-";
    } else {
      errors.address = "";
    }

    if (
      formValues.dlNumber != null &&
      formValues.dlNumber != "" &&
      formValues?.dlNumber?.length != 16
    ) {
      errors.dlNumber = "This is not a valid dl number, required 16 digits";
    } else {
      errors.dlNumber = "";
    }

    if (!formValues.dlNumber) {
      errors.dlExpiry = "dl number is required!";
    }

    setFormErrors(errors);
    return errors;
  };

  const history = useHistory();

  const reset = () => {
    history.push({
      pathname: "/Users",
      state: { table: 2, compomentRenderType: "view" },
    });
  };

  const handleSelectChange = (e) => {
    const nameValue = e.target.value.split("-:-");
    setFormValues({ ...formValues, [nameValue[0]]: nameValue[1] });
  };

  const handleDateChange = (name, e) => {
    if (e) {
      setFormValues({ ...formValues, [name]: new Date(e) });
    } else {
      setFormValues({ ...formValues, [name]: "" });
    }
  };

  return (
    <>
      <h2
        id="AddDriver_Heading"
        className={cn(styles.medium_title, styles.medium_title_layout)}
      >
        Driver
      </h2>

      <div
        id="AddDriver_Form_layout"
        className={cn(styles.group, styles.group_layout)}
      >
        <form id="AddDriver_Form">
          <div
            id="AddDriver_Form_layout1"
            className={cn(styles.flex3, styles.flex3_layout)}
          >
            <h3
              id="AddDriver_Form_title"
              className={cn(styles.subtitle, styles.subtitle_layout)}
            >
              {title}
            </h3>
            <hr className={cn(styles.line, styles.line_layout)} />

            <div
              id="AddDriver_Form_row1"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddDriver_EnterpriseName_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddDriver_EnterpriseName"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddDriver_EnterpriseName_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Enterprise Name*"}
                  </div>
                  <input
                    id="AddDriver_EnterpriseName_input"
                    type="text"
                    name="enterpriseName"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={
                      updateEnterprise == ""
                        ? formValues.enterpriseName
                        : updateEnterprise
                    }
                    onChange={handleChange}
                    disabled={true}
                  />
                </div>
                <p>{formErrors.enterpriseName}</p>
              </div>

              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddDriver_DriverName_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddDriver_DriverName_label"
                  className={cn(styles.text_body, styles.text_body_layout)}
                >
                  {"Driver Name*"}
                </div>
                <input
                  id="AddDriver_DriverName_input"
                  type="text"
                  name="firstName"
                  className={cn(styles.line1, styles.line1_layout)}
                  value={formValues.firstName}
                  onChange={handleChange}
                  disabled={onlyView}
                  maxLength={50}
                />

                <p>{formErrors.firstName}</p>
              </div>
            </div>

            <div
              id="AddDriver_Form_row2"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddDriver_PhoneNumber_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddDriver_PhoneNumber"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddDriver_PhoneNumber_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Phone Number*"}
                  </div>
                  <input
                    id="AddDriver_PhoneNumber_input"
                    type="text"
                    name="mobile_no"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.mobile_no}
                    onChange={handleChange}
                    disabled={onlyView || action === "Update"}
                    maxLength="10"
                  />
                </div>
                <p>{formErrors.mobile_no}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddDriver_EmailId_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddDriver_EmailId"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddDriver_EmailId_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Email Id"}
                  </div>
                  <input
                    id="AddDriver_EmailId_input"
                    type="email"
                    name="email"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.email}
                    onChange={handleChange}
                    disabled={onlyView}
                  />
                </div>
                <p>{formErrors.email}</p>
              </div>
            </div>

            <div
              id="AddDriver_Form_row3"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div id="AddDriver_State_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddDriver_State"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddDriver_State_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"State"}
                  </div>
                  <select
                    id="AddDriver_State_select"
                    name="stateId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.stateId}
                    onChange={handleChange}
                    disabled={onlyView}
                    required
                  >
                    <option value="-1"> Select State</option>
                    {state.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.state}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div id="AddDriver_City_block" className={cn(styles.flex2_item)}>
                <div
                  id="AddDriver_City"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddDriver_City_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"City"}
                  </div>
                  <select
                    id="AddDriver_City_select"
                    name="cityId"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.cityId}
                    onChange={handleChange}
                    disabled={onlyView}
                    required
                  >
                    <option value="-1"> Select City</option>
                    {city.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>
                <p>{formErrors.city}</p>
              </div>
            </div>

            <div
              id="AddDriver_Form_row4"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddDriver_Address_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddDriver_Address"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddDriver_Address_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Address"}
                  </div>
                  <input
                    id="AddDriver_Address_input"
                    type="text"
                    name="address"
                    className={cn(styles.line1, styles.line1_layout)}
                    value={formValues.address}
                    onChange={handleChange}
                    maxLength="250"
                    disabled={onlyView}
                  />
                </div>
                <p>{formErrors.address}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddDriver_DateOfBirth_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddDriver_DateOfBirth"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddDriver_DateOfBirth_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Date of Birth"}
                  </div>

                  {/* <hr className={cn(styles.line1, styles.line1_layout)} />  */}

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      name="DateOfBirth"
                      views={["year", "month", "day"]}
                      inputFormat="DD-MM-YYYY"
                      maxDate={
                        new Date(
                          new Date().setFullYear(new Date().getFullYear() - 18)
                        )
                      }
                      value={formValues.dateOfBirth}
                      onChange={(e) => handleDateChange("dateOfBirth", e)}
                      renderInput={(params) => <TextField {...params} />}
                      InputProps={{
                        disableUnderline: true,
                        style: { borderBottom: "2px solid rgb(175,180,197)" },
                      }}
                      disabled={onlyView}
                    />
                  </LocalizationProvider>
                </div>
                <p>{formErrors.dateOfBirth}</p>
              </div>
            </div>

            <div
              id="AddDriver_Form_row5"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddDriver_DrivingLicenceNumber_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddDriver_DrivingLicenceNumber_label"
                  className={cn(styles.text_body, styles.text_body_layout)}
                >
                  {"Driving Licence Number"}
                </div>
                <input
                  id="AddDriver_DrivingLicenceNumber_input"
                  type="text"
                  name="dlNumber"
                  className={cn(styles.line1, styles.line1_layout)}
                  value={formValues.dlNumber}
                  onChange={handleChange}
                  disabled={onlyView}
                  maxLength={16}
                />

                <p>{formErrors.dlNumber}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div
                id="AddDriver_DrivingLicenceExpiry_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddDriver_DrivingLicenceExpiry"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddDriver_DrivingLicenceExpiry_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Driving Licence Expiry"}
                  </div>

                  {/* <hr className={cn(styles.line1, styles.line1_layout)} />  */}
                  {/* <DateTimePicker
                    onChange={(e) => handleDateChange("dlExpiry", e)}
                    value={formValues.dlExpiry}
                    class={"react-datetime-picker__wrapper"}
                    disabled={onlyView}
                    format={formValues.dlExpiry ? "y-MM-dd" : "y-MM-dd"}
                  /> */}

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      name="Expiry"
                      views={["year", "month", "day"]}
                      inputFormat="DD-MM-YYYY"
                      value={formValues.dlExpiry}
                      minDate={
                        new Date(
                          new Date().setFullYear(new Date().getFullYear())
                        )
                      }
                      maxDate={
                        new Date(
                          new Date().setFullYear(
                            new Date().getFullYear() + 20
                          ) -
                            24 * 60 * 60 * 1000
                        ) 
                      }
                      onChange={(e) => handleDateChange("dlExpiry", e)}
                      renderInput={(params) => <TextField {...params} />}
                      InputProps={{
                        disableUnderline: true,
                        style: { borderBottom: "2px solid rgb(175,180,197)" },
                      }}
                      disabled={onlyView}
                    />
                  </LocalizationProvider>
                </div>
                <p>{formErrors.dlExpiry}</p>
              </div>
            </div>

            <div
              id="AddDriver_Form_row6"
              className={cn(styles.flex2, styles.flex2_layout)}
            >
              <div
                id="AddDriver_Status_block"
                className={cn(styles.flex2_item)}
              >
                <div
                  id="AddDriver_Status"
                  className={cn(styles.block3, styles.block3_layout)}
                >
                  <div
                    id="AddDriver_Status_label"
                    className={cn(styles.text_body, styles.text_body_layout)}
                  >
                    {"Status"}
                  </div>
                  <select
                    id="AddDriver_Status_select"
                    name="isActive"
                    className={cn(
                      styles.line1,
                      styles.line1_layout,
                      styles.style_select
                    )}
                    value={formValues.isActive}
                    onChange={handleChange}
                    disabled={onlyView || action === "Submit"}
                  >
                    <option value="true">Active</option>
                    <option value="false">Inactive</option>
                  </select>
                </div>
                <p>{formErrors.isActive}</p>
              </div>
              <div className={cn(styles.flex2_spacer)} />
              <div className={cn(styles.flex2_item)}></div>
            </div>

            {/* buttons ............ */}

            <div
              id="AddDriver_Button_container"
              className={cn(styles.flex9, styles.flex9_layout)}
            >
              <div
                id="AddDriver_Button_container1"
                className={cn(styles.flex9_item)}
                onClick={reset}
              >
                <div
                  id="AddDriver_BackButton_background"
                  className={cn(styles.block7, styles.block7_layout)}
                >
                  <h5
                    id="AddDriver_BackButton_title"
                    className={cn(
                      styles.highlights1,
                      styles.highlights1_layout
                    )}
                  >
                    {onlyView ? "Back" : "Cancel"}
                  </h5>
                </div>
              </div>
              <div className={cn(styles.flex9_spacer)} />
              {!onlyView && (
                // <div className={cn(styles.flex9_item)}>
                <div
                  id="AddDriver_SubmitButton_background"
                  style={{
                    width: "150px",
                    position: "relative",
                    bottom: "22px",
                  }}
                >
                  <button
                    id="AddDriver_SubmitButton"
                    className={cn(styles.block9, styles.block9_layout)}
                    onClick={handleSubmit}
                    disabled={buttonDisabled}
                  >
                    <h5
                      id="AddDriver_SubmitButton_title"
                      className={cn(
                        styles.highlights2,
                        styles.highlights2_layout
                      )}
                    >
                      {action}
                    </h5>
                  </button>
                </div>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default function AddDriver(props) {
  return (
    <>
      <Master opts={props} screen={AddDriverForm} showStatus={false} />
    </>
  );
}

AddDriver.inStorybook = true;
